let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9jQ2E")).then(() => parcelRequire('lB7uF'));